module.exports = __webpack_public_path__ + "img/stars.fa1bafd8.png";